// dietDay.js — 음식검색·식단추천에서 "식단에 추가"할 때 쓰는 공용 함수
// 그날 기록을 읽어 같은 끼니가 있으면 그 끼니에 덧붙이고, 없으면 끼니를 새로 만든 뒤 하루 저장 API 로 교체 저장
import { getDietHistDayInfo, postHistDaySave } from './dietApi';

export async function addFoodsToDay(date, dietCd, foods) {
  const res = await getDietHistDayInfo(date);
  const list = Array.isArray(res.data) ? res.data : [];

  const meals = new Map();
  list.forEach((it) => {
    const key = `${it.dietHistSeq}_${it.dietCd}`;
    if (!meals.has(key)) meals.set(key, { dietCd: it.dietCd, dietHistSeq: it.dietHistSeq, dietHistDtlDtoList: [] });
    meals.get(key).dietHistDtlDtoList.push({ foodCd: it.foodCd, intake: Number(it.intake) });
  });

  const add = foods.map((f) => ({ foodCd: f.foodCd, intake: Number(f.intake) }));
  const target = [...meals.values()].find((m) => m.dietCd === dietCd);
  if (target) target.dietHistDtlDtoList.push(...add);
  else meals.set(`new_${dietCd}`, { dietCd, dietHistSeq: null, dietHistDtlDtoList: add });

  return postHistDaySave(date, [...meals.values()]);
}

export const todayStr = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// 지금 시각 기준 기본 끼니
export const mealByHour = () => {
  const h = new Date().getHours();
  if (h < 10) return 'BR';
  if (h < 15) return 'LC';
  if (h < 21) return 'DN';
  return 'SN';
};
